import * as React from "react";
import { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import Patients from "./patients";
import BatchSubmission from "./BatchSubmission";
import Payment from "./payment";
import PublishIcon from "@mui/icons-material/Publish";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import VisitsManagment from "./visitsManagment";
import PriceListManagment from "./InsuranceViews/priceListManagment";
import MedicationList from "./InsuranceViews/medicationListManagment";
import Cookies from "js-cookie";
import PreAuthorization from "./PreAuthorization";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ClaimSubmission from "./ClaimSubmissionNew";
import ClaimsUpload from "./InsuranceViews/claimsUpload";
import VitalSigns from "./nurse";
import SickIcon from '@mui/icons-material/Sick';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import { useNavigate, useLocation } from "react-router-dom";
import MedicationIcon from '@mui/icons-material/Medication';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import PaymentReconsiliation from "./paymentReconcilation";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function SideNav(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [menuData, setMenuData] = useState("Home");
  const location = useLocation();
  const myProp = location.state ? location.state.role : null;
  const [activeMenuItem, setActiveMenuItem] = useState(null)
  const [patientsKey, setPatientsKey] = useState(null);
;
 

  useEffect(() => {
    if (myProp === "doctor") {
      setMenuData("Visits");
      setActiveMenuItem("Visits");

    } else if (myProp === "nurse") {
      setMenuData("vitalSigns");
      setActiveMenuItem("vitalSigns");

    } else if (myProp === "receptionist") {
      setMenuData("Patients");
      setActiveMenuItem("Patients");

    } else if (myProp === "financial") {
      setMenuData("priceList");
      setActiveMenuItem("priceList");

    } else {
      setMenuData("Patients")
      setActiveMenuItem("Patients");

    }
    if (!Cookies.get("RCM_KSA_Employee_Token")) {
      navigate("/")
    }
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logoutBtn = () => {

    Cookies.remove("RCM_KSA_Employee_Token", { path: '/' });
    setMenuData("")
    navigate("/");


  };
  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(menuItem);
    setMenuData(menuItem)
    if (menuItem === "Patients") {
      setPatientsKey(Date.now());
    } else {
      setPatientsKey(null);
    }
  };
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        style={{ backgroundColor: "rgb(61 65 68)" }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            SAMA
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader style={{ backgroundColor: "rgb(61 65 68)" }}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon style={{ color: "white" }} />
            ) : (
              <ChevronLeftIcon style={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <div>
          <Typography variant="h6" noWrap component="div" style={{ textTransform:"capitalize",fontSize:"16px" }}>
            {localStorage.getItem('nphies-provider-name')}
          </Typography>
          <Typography variant="h6" noWrap component="div" style={{ textTransform:"capitalize",fontSize:"16px"}}>
            Welcome {localStorage.getItem('doctor-name')}
          </Typography>
        </div>
        <List>
          {myProp === "receptionist" ? (
            <>
              {/* <ListItem button onClick={() => handleMenuItemClick("Home")} selected={activeMenuItem === "Home"}
              >
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Home" />
              </ListItem> */}
              <ListItem button onClick={() => handleMenuItemClick("Patients")} selected={activeMenuItem === "Patients"}>
                <ListItemIcon>
                  <PersonAddIcon />
                </ListItemIcon>
                <ListItemText primary="Patients" />
              </ListItem>
              {/* <ListItem button onClick={() => setMenuData("Batch Submission")}>
              <ListItemIcon><PublishIcon /></ListItemIcon>
              <ListItemText primary="Batch Submission" />
            </ListItem>
            <ListItem button onClick={() => setMenuData("Payment")}>
              <ListItemIcon><AttachMoneyIcon /></ListItemIcon>
              <ListItemText primary="Payment" />
            </ListItem> */}
            </>
          ) : myProp === "doctor" ? (
            <>
              <ListItem button onClick={() => handleMenuItemClick("Visits")} selected={activeMenuItem === "Visits"}>
                <ListItemIcon>
                  <ManageAccountsIcon />
                </ListItemIcon>
                <ListItemText primary="Visits Management" />
              </ListItem>
            </>
          ) : myProp === "financial" ? (
            <>
              <ListItem button onClick={() => handleMenuItemClick("priceList")} selected={activeMenuItem === "priceList"}>
                <ListItemIcon>
                  <PriceCheckIcon />
                </ListItemIcon>
                <ListItemText primary="Price List " />
              </ListItem>
              <ListItem button onClick={() =>handleMenuItemClick("medicationList")} selected={activeMenuItem === "medicationList"}>
                <ListItemIcon>
                  <ManageAccountsIcon />
                </ListItemIcon>
                <ListItemText primary="Medication List Management" />
              </ListItem>
              <ListItem button onClick={() => setMenuData("PreAuthorization")}>
                <ListItemIcon>
                  <HowToRegIcon />
                </ListItemIcon>
                <ListItemText primary="Pre Authorization" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("claimSubmission")} selected={activeMenuItem === "claimSubmission"}>
                <ListItemIcon>
                  <ArrowUpwardIcon />
                </ListItemIcon>
                <ListItemText primary="Claim Submission" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("claimsUpload")} selected={activeMenuItem === "claimsUpload"}>
                <ListItemIcon>
                  <UploadFileIcon />
                </ListItemIcon>
                <ListItemText primary="Claims Upload" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("payment")} selected={activeMenuItem === "payment"}>
                <ListItemIcon>
                  <PaidOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Payments" />
              </ListItem>
            </>
          ) : myProp === "nurse" ? (<>
            <ListItem button onClick={() => handleMenuItemClick("vitalSigns")} selected={activeMenuItem === "vitalSigns"}>
              <ListItemIcon>
                <SickIcon />
              </ListItemIcon>
              <ListItemText primary="Vital Signs" />
            </ListItem>
          </>) : myProp === "super" ? (
            <>
              {/* <ListItem button onClick={() => handleMenuItemClick("Home")} selected={activeMenuItem === "Home"}>
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Home" />
              </ListItem> */}
              <ListItem button onClick={() => handleMenuItemClick("Patients")} selected={activeMenuItem === "Patients"}>
                <ListItemIcon>
                  <PersonAddIcon />
                </ListItemIcon>
                <ListItemText primary="Patients" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("vitalSigns")} selected={activeMenuItem === "vitalSigns"}>
                <ListItemIcon>
                  <SickIcon />
                </ListItemIcon>
                <ListItemText primary="Vital Signs" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("Visits")} selected={activeMenuItem === "Visits"}>
                <ListItemIcon>
                  <ManageAccountsIcon />
                </ListItemIcon>
                <ListItemText primary="Visits Management" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("PreAuthorization")} selected={activeMenuItem === "PreAuthorization"}>
                <ListItemIcon>
                  <HowToRegIcon />
                </ListItemIcon>
                <ListItemText primary="Pre Authorization" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("claimSubmission")} selected={activeMenuItem === "claimSubmission"}>
                <ListItemIcon>
                  <ArrowUpwardIcon />
                </ListItemIcon>
                <ListItemText primary="Claim Submission" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("claimsUpload")} selected={activeMenuItem === "claimsUpload"}>
                <ListItemIcon>
                  <UploadFileIcon />
                </ListItemIcon>
                <ListItemText primary="Claims Upload" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("priceList")} selected={activeMenuItem === "priceList"}>
                <ListItemIcon>
                  <PriceCheckIcon />
                </ListItemIcon>
                <ListItemText primary="Price List " />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("medicationList")} selected={activeMenuItem === "medicationList"}>
                <ListItemIcon>
                  <MedicationIcon />
                </ListItemIcon>
                <ListItemText primary="Medication List" />
              </ListItem>
              <ListItem button onClick={() => handleMenuItemClick("payment")} selected={activeMenuItem === "payment"}>
                <ListItemIcon>
                  <PaidOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Payments" />
              </ListItem>
            </>
          ) : null}
          <ListItem button onClick={logoutBtn}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        {menuData === "Patients" && <Patients key={patientsKey} />}
        {/* {menuData === "Batch Submission" && <BatchSubmission />}
        {menuData === "Payment" && <Payment />} */}
        {menuData === "Visits" && <VisitsManagment />}
        {menuData === "priceList" && <PriceListManagment />}
        {menuData === "medicationList" && <MedicationList />}
        {menuData === "PreAuthorization" && <PreAuthorization />}
        {menuData === "claimSubmission" && <ClaimSubmission />}
        {menuData === "claimsUpload" && <ClaimsUpload />}
        {menuData === "vitalSigns" && <VitalSigns />}
        {menuData === "payment" && <PaymentReconsiliation />}
      </Box>
    </Box>
  );
}
